@if ((userService.currentUser | async).planInfo.addressUpdateNeeded) {
    <fm-update-address-banner class="w-full z-40" />
}
@if (showMaintenanceBanner) {
    <fm-maintenance-banner class="w-full z-50" />
}

@if (showGroupMeetingsBetaLaunchHostAnnouncementBanner()) {
    <fm-group-meeting-beta-launch-host-announcement-banner />
} @else if (showGroupMeetingsBetaLiveHostAnnouncementBanner()) {
    <fm-group-meeting-beta-live-host-announcement-banner />
} @else if (showGroupMeetingsHostBetaBanner()) {
    <fm-group-meeting-host-beta-banner (dismissBanner)="dismissGroupMeetingsHostBetaBanner()" />
}

@if (showHostRecruitmentBanner()) {
    <fm-host-recruitment-banner (dismissBanner)="dismissHostRecruitmentBanner()" />
}

@if (systemBannerService.bannerSubject | async) {
    <fm-system-banner [banner]="systemBannerService.bannerSubject | async" />
}

@if (serverTimeService.systemTimeOutOfSync()) {
    <fm-time-sync-banner />
}
@if ((userService.isAuthenticated | async) && !(userService.isEmailVerified | async)) {
    <fm-email-verification-banner
        [email]="(userService.currentUser | async).email"
        [isSent]="userService.sentEmailVerification | async"
        (openVerification)="launchVerify()"
        (resendVerification)="sendEmailVerification()" />
}
@if ((userService.currentUser | async).suspended) {
    <fm-suspended-banner (openSuspension)="launchSuspended()" />
}
